import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  Typography,
  withStyles
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import isUndefined from 'lodash/isUndefined';

// Icons
import Close from '@material-ui/icons/Close';
import DoneCircle from '../../img/integrations/done_circle.svg';

const styles = () => ({
  dialog: {
    padding: '25px'
  },
  title: {
    fontSize: '18px',
    fontWeight: 500,
    textAlign: 'left'
  },
  content: {
    padding: '0 10px 10px'
  },
  gridMarginIconDone: {
    margin: '0px 0px 13px 0px'
  },
  gridMargin: {
    margin: '13px 0px'
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'center',
    margin: '15px 0'
  },
  button: {
    fontFamily: 'Roboto',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    textTransform: 'uppercase',
    letterSpacing: '1.25px',
    color: '#fff',
    border: 'none',
    boxShadow: 'none',
    padding: '10px 28px',
    margin: '0 7px',
    height: '52px',
    width: '100%'
  },
  default: {
    backgroundColor: '#f5f5f5',
    border: '1px solid',
    borderColor: '#d1d4dd',
    color: '#646777',
    '&:hover': {
      backgroundColor: '#efefef'
    }
  },
  primary: {
    backgroundColor: '#4bbc68',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#1e9c3e'
    }
  },
  doneCircle: {
    width: '40px',
    height: '40px',
    flexGrow: '0',
    objectFit: 'contain',
    color: '#D1D4DD'
  },
  closeContainer: {
    textAlign: 'end',
    height: '22px'
  }
});

const DialogTitle = withStyles({
  root: {
    margin: 0,
    padding: '15px'
  },
  closeButton: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    color: '#D1D4DD'
  }
})(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const SuccessModal = ({
  open = false,
  title = '',
  toggle,
  successAction,
  cancelAction,
  textButton = 'Continuar',
  classes,
  children
}) => {
  const searchTitle = () => {
    if (!isUndefined(title))
      return (
        title.includes('Has creado la organización') ||
        title.includes('Hemos actualizado los cambios en tu organización')
      );
    return false;
  };

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      classes={{ paper: classes.dialog }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {!searchTitle() && <DialogTitle id="alert-dialog-title" onClose={toggle ? toggle : (cancelAction ? cancelAction : successAction)} />}
      {searchTitle() && (
        <div className={classes.closeContainer}>
          <IconButton aria-label="Close" className={classes.closeButton} onClick={successAction}>
            <Close />
          </IconButton>
        </div>
      )}
      <DialogContent className={classes.content}>
        <DialogContentText id="alert-dialog-description">
          <Grid className={classes.gridMargin} container>
            <Grid className={classes.gridMarginIconDone} container>
              <Grid item xs={12}>
                <img src={DoneCircle} alt="check_done" className={classes.doneCircle} />
              </Grid>
            </Grid>
            <Grid className={classes.gridMargin} container>
              <Grid item xs={12}>
                <Typography className={classes.title}>{title}</Typography>
              </Grid>
            </Grid>
            {children}
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actionButtons}>
        {cancelAction && (
          <Button onClick={cancelAction} className={`${classes.button} ${classes.default}`} variant="contained">
            CANCELAR
          </Button>
        )}
        <Button
          fullWidth
          onClick={successAction}
          className={`${classes.button} ${classes.primary}`}
          variant="contained"
        >
          {textButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  toggle: PropTypes.func,
  successAction: PropTypes.func.isRequired,
  cancelAction: PropTypes.func,
  textButton: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};

export default withStyles(styles)(SuccessModal);



// WEBPACK FOOTER //
// ./src/components/modal/SuccessModal.js